import React, { FunctionComponent } from 'react'

type TagIconProps = {
  size: number
  color?: string
}

const TagIcon: FunctionComponent<TagIconProps> = ({
  size,
  color = '#384A51',
}: TagIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <path
        d="M13.707 3.293C13.6143 3.19996 13.5041 3.12617 13.3828 3.07589C13.2614 3.0256 13.1313 2.99981 13 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V13C3 13.266 3.105 13.52 3.293 13.707L11.293 21.707C11.3857 21.8002 11.4958 21.8741 11.6171 21.9246C11.7385 21.9751 11.8686 22.001 12 22.001C12.1314 22.001 12.2615 21.9751 12.3829 21.9246C12.5042 21.8741 12.6143 21.8002 12.707 21.707L21.707 12.707C21.7999 12.6142 21.8737 12.504 21.924 12.3827C21.9743 12.2614 22.0002 12.1313 22.0002 12C22.0002 11.8687 21.9743 11.7386 21.924 11.6173C21.8737 11.496 21.7999 11.3858 21.707 11.293L13.707 3.293ZM12 19.586L5 12.586V5H12.586L19.586 12L12 19.586Z"
        fill={color}
      />
      <path
        d="M8.496 10C9.32719 10 10.001 9.32619 10.001 8.495C10.001 7.66381 9.32719 6.99 8.496 6.99C7.66481 6.99 6.991 7.66381 6.991 8.495C6.991 9.32619 7.66481 10 8.496 10Z"
        fill={color}
      />
    </svg>
  )
}

export default TagIcon
